import * as React from "react";
import { connect } from "react-redux";
import { Button, Result, Col } from "antd";

import { MainComponentContainer } from "../../../shared/MainComponentContainer";
import RowWrapper from "../../../shared/RowWrapper";

function BookSuccess(props: any) {
  return (
    <MainComponentContainer>
      <RowWrapper type="flex">
        <Col span={24}>
          <Result
            status="success"
            title="Vielen Dank für Ihre Anfrage"
            subTitle="Wir setzen uns schnellstmöglich mit Ihnen in Verbindung um weitere Details zu klären."
            extra={
              <Button key="buy" onClick={() => props.history.goBack()}>
                Weitere Anfrage
              </Button>
            }
          />
        </Col>
      </RowWrapper>
    </MainComponentContainer>
  );
}

export default connect()(BookSuccess);
